import { render, staticRenderFns } from "./itemBulletin.vue?vue&type=template&id=2dccef68&"
import script from "./itemBulletin.vue?vue&type=script&lang=js&"
export * from "./itemBulletin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports